import { render, staticRenderFns } from "./PersonalizePreview.vue?vue&type=template&id=36f76028&"
import script from "./PersonalizePreview.vue?vue&type=script&lang=js&"
export * from "./PersonalizePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports